import React from 'react';
import { Typography } from '@material-ui/core';
import ImageBlocks from '../../../ImageBlocks';

import './Services.css';

const Services = ({ reference }) => {

  const departmentImages = [
    'service-1.jpg',
    'service-2.jpeg',
    'service-3.jpg',
  ];

  return (
    <div className="Services Services__Container" ref={reference}>
      <div className="Services__Title">
        <Typography variant="h5" color="primary">
          Servicios que ofrecemos
        </Typography>
      </div>

      <div className="Services__Content">
        <ul>
          <li>Ropa Blanca</li>
          <li>Con o sin desayuno</li>
          <li>Estacionamiento cubierto</li>
          <li>Pileta de 2 niveles, una baja (30cm) ideal para los más chicos y otra onda de 140cm, con su Barra y Jacuzzi</li>
          <li>Club House con bar, pool, metegol, ping-pong y juegos para los mas chicos</li>
          <li>Quincho con 4 asadores y un amplio predio de esparcimiento natural y autóctono</li>
          <li>Gimnasio, Sauna y Jacuzzi con excelente vista</li>
          <li>Servicio Médico de Urgencias</li>
          <li>Wi-Fi libre</li>
        </ul>

        <ImageBlocks images={departmentImages} />
      </div>
    </div>

  );
};

export default Services;
